import ufc from "@tvg/api/ufc";
import { get } from "lodash";

const getUserFavoriteTracks = (accountNumber) =>
  ufc.getUserAlerts(accountNumber.toString(), "track").then(({ data }) => {
    const userFavorites = {};
    const ufcFavoriteTracks = data.favorites.filter(
      (favorite) =>
        !favorite.subscriptions.length ||
        (favorite.subscriptions.length &&
          favorite.subscriptions &&
          favorite.subscriptions[0] === null &&
          favorite.subscriptions.length === 1)
    );
    ufcFavoriteTracks.forEach((ufcFavorite) => {
      userFavorites[ufcFavorite.entityName] = ufcFavorite.favoriteId;
    });

    return userFavorites;
  });

const getUserRaceAlerts = (accountNumber, entityType) =>
  ufc
    .getUserAlerts(accountNumber, entityType)
    .then((results) => get(results, "data.favorites", []));

export default {
  getUserFavoriteTracks,
  getUserRaceAlerts
};
